import React from 'react';
import Container from '../../../../constants/Container';
import SecHeading from '../../../../constants/SecHeading';
import { Grid } from '@mui/material';
import InputTextBox from '../../../../constants/InputTextBox';
import { EndBaseLine } from '../../../../constants/AppSpace';
import { Button } from '../../../../constants/Button';
import { useFormik } from 'formik';
import { postDataToTheServer } from '../../../../helpers/api';
import AppURL from '../../../../constants/AppURL';
import { ToastSuccess, ToastWarning } from '../../../../constants/Toast';
import { CiCalendarDate } from 'react-icons/ci';
import { NepNowDateFormat } from '../../../../constants/DateFormat';
import { handleChangeDate, handleSelectBox } from '../../../../helpers/handleChange';
import SelectInputBox from '../../../../constants/SelectInputBox';
import { IssueProductListReducer, ProductMaster } from '../../../../helpers/models/Models';
import { ISSUE_PRODUCT_LIST } from '../../../../store/inventorySlice';

import { MasterCategoryOptions, ProductListIssueOptions, ProductMemberIssueOptions, ProductStoreOptions, SubCategoryOptions } from '../../../../constants/Options';
import useFetchSubData from '../../../../helpers/useSubFetch';
import { useDispatch } from 'react-redux';
import { issueDataPost } from '../../../../helpers/submitDataOnServer';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { proIssuevalidationSchema } from '../../../../helpers/validation';
interface ItemCategoryFormViewProps {
    data: {
        results: ProductMaster[]
    } | null;
    loading: boolean;
}
const ProductIssueFormView: React.FC<ItemCategoryFormViewProps> = ({ data }) => {
    const { IssueProductList } = useSelector((state: RootState) => state.inventory);
    const masterCategoryOptions = MasterCategoryOptions(data?.results)
    const dispatch = useDispatch();
    const nepDate = NepNowDateFormat();
    const initialValues = {
        master_category: "",              // Corresponds to "name"
        pur_sale_date: nepDate || "",
        product_category: "",        // Corresponds to "name_nep"
        product: "",
        sub_master: "",
        store: "",
        payment_mode: "0",
        purchase_rate: "0",
        issue_qty: "",
        tot_amt: "",
        due_date: "",
        remarks: "",
        vat_amt: "0",
        dis_amt: "0",
        dis_per: "0",
        member_sn: "",
        total_issuable: "",
        pur_tot_amt: "0",
    };
    const { values, errors, touched, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        validationSchema: proIssuevalidationSchema,
        enableReinitialize: true,
        onSubmit: async (values, action) => {
            // Sum the issue quantities for the same product across all stores
            const totalIssuedQty = IssueProductList
                .filter(item => item.product === parseInt(values.product))
                .reduce((sum, item) => sum + item.issue_qty, 0);

            // Calculate the remaining issuable quantity
            const remainingIssuableQty = parseInt(values.total_issuable) - totalIssuedQty;

            // Check if the new issue quantity exceeds the remaining issuable quantity
            if (parseInt(values.issue_qty) > remainingIssuableQty) {
                ToastWarning({ message: "Issue Quantity exceeds available stock" });
                return;
            }


            const newProducts: IssueProductListReducer[] = [
                {
                    master_category: parseInt(values.master_category) || 0,
                    pur_sale_date: values.pur_sale_date,
                    product_category: parseInt(values.product_category) || 0,
                    product: parseInt(values.product) || 0,
                    store: values.store || 0,
                    purchase_rate: parseFloat(values.purchase_rate || '0'),
                    remarks: values.remarks,
                    issue_qty: parseInt(values.issue_qty),
                    vat_amt: parseFloat(values.vat_amt || '0'),
                    dis_amt: parseFloat(values.dis_amt || '0'),
                    dis_per: parseFloat(values.dis_per || '0'),
                    tot_amt: parseFloat(values.tot_amt || '0'),
                    pur_tot_amt: parseFloat(values.pur_tot_amt || '0'),
                    due_date: values.due_date,
                    payment_mode: 0,
                    member_sn: parseInt(values.member_sn)
                }
            ];
            try {
                if (parseInt(values.issue_qty) > 0) {
                    try {
                        dispatch(ISSUE_PRODUCT_LIST(newProducts));
                        action.resetForm();
                    } catch (error) {
                        console.error("Error saving product purchase:", error);
                    }
                } else {
                    ToastWarning({ message: "Issue Qty more than 0" });
                }
            } catch (error) {
                console.error("Error saving product purchase:", error);
            }
        },
    });

    const { data: sub_category, loading, error } = useFetchSubData(AppURL.InventoryURL + "inventory/product/category/master/wise/list/?product_master=" + values.master_category, values.master_category);
    const subCategoryOptions = SubCategoryOptions(sub_category?.sub_category);
    const { data: pro_member_data, loading: pro_member_loading, error: pro_member_error, refetch } = useFetchSubData(AppURL.InventoryURL + "inventory/product/with/member/options/list/view/?sub_master=" + values.sub_master + "&store=" + values.store, values.sub_master && values.store);
    const productListIssueOptions = ProductListIssueOptions(pro_member_data?.products);
    const productMemberIssueOptions = ProductMemberIssueOptions(pro_member_data?.members);
    const productStoreOptions = ProductStoreOptions(sub_category?.product_store || []);
    const handleSaveSubmit = async () => {
        await issueDataPost(IssueProductList, dispatch);
        refetch();
    };

    return (
        <Container padding={true}>
            <form onSubmit={handleSubmit}>
                <SecHeading type='add' label='Add Issue Product' />
                <Grid container columnSpacing={3} rowSpacing={0.8}>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <SelectInputBox
                            label='Master Category'
                            options={masterCategoryOptions}
                            name='master_category'
                            required={true}
                            placeholder='Select meter status'
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }}
                            handleBlur={() => {
                                handleBlur({ target: { name: 'master_category' } });
                            }}

                            value={values.master_category}
                            touched={touched.master_category}
                            errors={errors.master_category}
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <SelectInputBox
                            label='Product Category'
                            options={subCategoryOptions}
                            name='sub_master'
                            required={true}
                            placeholder='Select Product Category'
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }}
                            handleBlur={() => {
                                handleBlur({ target: { name: 'sub_master' } });
                            }}
                            value={values.sub_master}
                            touched={touched.sub_master}
                            errors={errors.sub_master}
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <SelectInputBox
                            label='Product Store'
                            options={productStoreOptions}
                            name='store'
                            required={true}
                            placeholder='Select Product Store'
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }}
                            handleBlur={() => {
                                handleBlur({ target: { name: 'store' } });
                            }}
                            value={values.store}
                            touched={touched.store}
                            errors={errors.store}
                        />
                    </Grid>

                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <SelectInputBox
                            label='Product'
                            options={productListIssueOptions}
                            name='product'
                            required={true}
                            isLoading={pro_member_loading}
                            placeholder='Select Product'
                            optionSelect={(name, selectedOption) => {
                                setFieldValue("total_issuable", selectedOption.total_issuable);
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }}
                            handleBlur={() => {
                                handleBlur({ target: { name: 'product' } });
                            }}
                            value={values.product}
                            touched={touched.product}
                            errors={errors.product}
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <InputTextBox
                            type='number'
                            name='issue_qty'
                            label='Issue QTY'
                            handleChange={handleChange}
                            value={values.issue_qty}
                            error={errors.issue_qty?.toString()}
                            handleBlur={handleBlur}
                            touched={touched.issue_qty ? Boolean(touched.issue_qty) : undefined}
                            required={true}
                            placeholder='0'
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <SelectInputBox
                            label='Staff Member'
                            options={productMemberIssueOptions}
                            name='member_sn'
                            isLoading={pro_member_loading}
                            required={true}
                            placeholder='Select Staff Member'
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }}
                            handleBlur={() => {
                                handleBlur({ target: { name: 'member_sn' } });
                            }}
                            value={values.member_sn}
                            touched={touched.member_sn}
                            errors={errors.member_sn}
                        />
                    </Grid>

                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            prefix={<CiCalendarDate />}
                            name='pur_sale_date'
                            label='Issue Date'
                            handleChange={handleChange}
                            value={values.pur_sale_date}
                            error={errors.pur_sale_date?.toString()}
                            handleBlur={handleBlur}
                            touched={touched.pur_sale_date ? Boolean(touched.pur_sale_date) : undefined}
                            required={true}
                            disabled
                            placeholder='XXXX/XX/XX'
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            prefix={<CiCalendarDate />}
                            name='due_date'
                            label='Return Date'
                            handleChange={(e) => handleChangeDate(e, { setFieldValue, name: 'due_date' })}
                            value={values.due_date}
                            error={errors.due_date?.toString()}
                            handleBlur={handleBlur}
                            touched={touched.due_date ? Boolean(touched.due_date) : undefined}
                            required={true}
                            placeholder='XXXX/XX/XX'
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <EndBaseLine top={18}>
                            <Button btn_type='save' onClick={handleSaveSubmit} type='button' el='button' />
                            <Button btn_type='add' type='submit' el='button' />
                        </EndBaseLine>
                    </Grid>
                </Grid>
            </form>

        </Container>
    )
}

export default ProductIssueFormView